import React from 'react';
import { FlexRow } from '@make-software/tg-mini-app-ui';

import { RoundStatCard } from './round-stat-card';

interface IRoundStatsProps {
  supporters?: number;
  rankPoints?: number | string;
  supportRankText?: string;
  onClick?: () => void;
  isSecondRound?: boolean;
}

export const RoundStats: React.FC<IRoundStatsProps> = ({
  supporters = 12,
  rankPoints = 15250,
  supportRankText = '',
  onClick,
  isSecondRound
}) => (
  <FlexRow gap={20} style={{ marginTop: 12, marginBottom: 28 }}>
    <RoundStatCard
      icon="users"
      primary={supporters}
      secondary="votes have been sent to this project"
      onClick={onClick}
      isSecondRound={isSecondRound}
    />
    <RoundStatCard
      icon="earn"
      primary={rankPoints}
      secondary={supportRankText}
      onClick={onClick}
      isSecondRound={isSecondRound}
    />
  </FlexRow>
);
